const tr = {
  push:{
    attributes:{
      user_id:            'ID de usuário',
      image_id:           'ID de imagem',
      image_url:          'URL da imagem',
      title:              'Título',
      subtitle:           'Subtítulo',
      message:            'Mensagem',
      link_url:           'Link URL',
      template_id:        'ID do template',
      sent_at:            'Agendar envio',
      send_at:            'Data de criação',
      filter:             'Filtros',
      image:              'Imagem',
      image_base64:       'Imagem',
      title_en:           'Título - EN',
      message_en:         'Mensagem - EN',
      subtitle_en:        'Subtítulo - EN',
      title_es:           'Título - ES',
      subtitle_es:        'Subtítulo - ES',
      message_es:         'Mensagem - ES',
      users_received:     'Usuários que receberam'
    },
    extras:{
      create_push: 'Nova mensagem de push',
      edit_push: 'Editando mensagem de push',
      show_push: 'Visualizando mensagem de push',
      delete_push: 'Excluir mensagem de push',
    },
    defSingular: 'Mensagem',
    defPlural: 'Mensagens',
  }
};

export default tr;
